import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import MachineForm from "../../components/maintenance/MachineForm";
import {
  fetchMachine,
  fetchMachineSuccess,
  fetchMachineFailure,
  createMachine,
  createMachineSuccess,
  createMachineFailure,
  updateMachine,
  updateMachineSuccess,
  updateMachineFailure,
  fetchMachineTypes,
  fetchMachineTypesSuccess,
  fetchMachineTypesFailure,
  fetchMaintenanceLocations,
  fetchMaintenanceLocationsSuccess,
  fetchMaintenanceLocationsFailure,
  clearCurrentMachine,
} from "../../store/maintenance/actions";

const MachineFormContainer = ({
  machines,
  machineTypes,
  locations,
  fetchMachine,
  createMachine,
  updateMachine,
  fetchMachineTypes,
  fetchMaintenanceLocations,
  clearCurrentMachine,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;

  useEffect(() => {
    fetchMachineTypes();
    fetchMaintenanceLocations();
    if (isEdit) {
      fetchMachine(id);
    }
    return () => {
      clearCurrentMachine();
    };
  }, [id, isEdit, fetchMachine, fetchMachineTypes, fetchMaintenanceLocations, clearCurrentMachine]);

  const handleSubmit = useCallback(
    (data) => {
      if (isEdit) {
        updateMachine(id, data, () => {
          navigate(`/maintenance/machines/${id}`);
        });
      } else {
        createMachine(data, (newMachine) => {
          navigate(`/maintenance/machines/${newMachine.id}`);
        });
      }
    },
    [isEdit, id, createMachine, updateMachine, navigate]
  );

  return (
    <MachineForm
      machine={machines.current}
      machineTypes={machineTypes.list}
      locations={locations.list}
      loading={machines.loading || machineTypes.loading || locations.loading}
      error={machines.error}
      onSubmit={handleSubmit}
      isEdit={isEdit}
    />
  );
};

const mapStateToProps = (state) => ({
  machines: state.maintenance.machines,
  machineTypes: state.maintenance.machineTypes,
  locations: state.maintenance.locations,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMachine: (id) => {
    dispatch(fetchMachine(id)).payload.then(
      (response) => {
        dispatch(fetchMachineSuccess(response.data));
      },
      (error) => {
        dispatch(fetchMachineFailure(error.response?.data || error));
      }
    );
  },
  createMachine: (data, callback) => {
    dispatch(createMachine(data)).payload.then(
      (response) => {
        dispatch(createMachineSuccess(response.data));
        if (callback) callback(response.data);
      },
      (error) => {
        dispatch(createMachineFailure(error.response?.data || error));
      }
    );
  },
  updateMachine: (id, data, callback) => {
    dispatch(updateMachine(id, data)).payload.then(
      (response) => {
        dispatch(updateMachineSuccess(response.data));
        if (callback) callback(response.data);
      },
      (error) => {
        dispatch(updateMachineFailure(error.response?.data || error));
      }
    );
  },
  fetchMachineTypes: () => {
    dispatch(fetchMachineTypes(1, null, null, 9999)).payload.then(
      (response) => {
        dispatch(fetchMachineTypesSuccess(response.data));
      },
      (error) => {
        dispatch(fetchMachineTypesFailure(error.response?.data || error));
      }
    );
  },
  fetchMaintenanceLocations: () => {
    dispatch(fetchMaintenanceLocations(1, null, null, 9999)).payload.then(
      (response) => {
        dispatch(fetchMaintenanceLocationsSuccess(response.data));
      },
      (error) => {
        dispatch(fetchMaintenanceLocationsFailure(error.response?.data || error));
      }
    );
  },
  clearCurrentMachine: () => {
    dispatch(clearCurrentMachine());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MachineFormContainer);
